import { render, staticRenderFns } from "./Contacts.container.vue?vue&type=template&id=115f09e7&scoped=true&"
import script from "./Contacts.container.vue?vue&type=script&lang=js&"
export * from "./Contacts.container.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.container.vue?vue&type=style&index=0&id=115f09e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f09e7",
  null
  
)

export default component.exports